import { createSelector } from 'reselect';

const innerStateSelector = state => state.tip

const tipDataSelector = createSelector(
   innerStateSelector,
   state => state.tipData
);
const isFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isFetching
);

const tipModalDataSelector = createSelector(
   innerStateSelector,
   state => state.tipModalData
);
const isCheckLimitFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isCheckLimitFetching
);


export {
   tipDataSelector,
   isFetchingSelector,
   tipModalDataSelector,
   isCheckLimitFetchingSelector,
}
